"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
function GetBroadcasts() {
    var _a = (0, react_1.useState)(''), broadcasts = _a[0], setBroadcasts = _a[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get('/api/v2/students/initiate?lang=' + Lang_js_1.lang)
            .then(function (response) {
            setBroadcasts(response.data.initiate.recordings);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    if (!broadcasts) {
        return react_1.default.createElement(Box_1.default, null, "Loading...");
    }
    return (react_1.default.createElement(Box_1.default, { className: "container student-container" },
        react_1.default.createElement(Box_1.default, { dangerouslySetInnerHTML: { __html: broadcasts } })));
}
exports.default = GetBroadcasts;
var broadcastsContainer = document.getElementById('broadcasts');
if (broadcastsContainer) {
    (0, mountIsland_1.mountIsland)(broadcastsContainer, react_1.default.createElement(GetBroadcasts, null));
}
